import { Upload } from "@simplebooth/webkit"
import sample1 from "../image/sample/sample-1.jpg"
import sample1Sm from "../image/sample/sample-1_sm.jpg"
import sample2 from "../image/sample/sample-2.jpg"
import sample2Sm from "../image/sample/sample-2_sm.jpg"
import sample3 from "../image/sample/sample-3.jpg"
import sample3Sm from "../image/sample/sample-3_sm.jpg"

const SAMPLE_PHOTOS = [
  { full: sample1, small: sample1Sm },
  { full: sample2, small: sample2Sm },
  { full: sample3, small: sample3Sm },
]

const SAMPLE_WIDTH = 900
const SAMPLE_HEIGHT = 1200

export function createMockUploads(count: number = 24): Upload[] {
  const uploads: Upload[] = []
  for (let i = 0; i < count; i++) {
    const { full, small } = SAMPLE_PHOTOS[i % SAMPLE_PHOTOS.length]

    const upload = new Upload()
    upload.code = `mock_${i}`
    upload.mimeType = "image/jpeg"
    upload.layout = null
    upload.setMedia(full, small, small)
    upload.createdAt = Date.now() - i * 60_000
    upload.public = true
    upload.deleted = false
    upload.approved = true
    upload.processed = true
    upload.dimensions = {
      width: SAMPLE_WIDTH,
      height: SAMPLE_HEIGHT,
      aspect: SAMPLE_WIDTH / SAMPLE_HEIGHT,
    }
    upload.viewCount = null
    upload.links.self = "#"

    uploads.push(upload)
  }
  return uploads
}
